import styled from 'styled-components';
import { colors } from '../../../utils/utils';

const Input = styled.input`
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: 2px solid ${colors.white.lilac};
    padding: 25px 15px;
    font-size: 15px;
    color: ${colors.blue.madison};
    opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
`;

export default Input;
